import React from "react";
import { X } from "lucide-react";
import { API_BASE } from "@/lib/api";
import { parseVideoLink } from "@/lib/videoLinks";

// Full-screen player: uploaded videos stream from the API (token via ?auth=),
// links become YouTube/Vimeo embeds or a direct <video>.
export const VideoPlayerModal = ({ video, onClose }) => {
  const token = localStorage.getItem("fp_token");

  let player = null;
  if (video.source === "upload") {
    player = (
      <video
        controls
        autoPlay
        playsInline
        className="w-full max-h-[70vh] bg-black rounded-sm"
        src={`${API_BASE}/videos/${video.id}/file?auth=${encodeURIComponent(token || "")}`}
        data-testid="video-player-file"
      />
    );
  } else {
    const parsed = parseVideoLink(video.url);
    player =
      parsed.kind === "iframe" ? (
        <iframe
          title={video.title}
          src={parsed.src}
          className="w-full aspect-video rounded-sm"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid="video-player-embed"
        />
      ) : (
        <video
          controls
          autoPlay
          playsInline
          className="w-full max-h-[70vh] bg-black rounded-sm"
          src={parsed.src}
          data-testid="video-player-direct"
        />
      );
  }

  return (
    <div className="fixed inset-0 bg-black/80 z-40 grid place-items-center p-4" data-testid="video-player-modal" onClick={onClose}>
      <div className="bg-obsidian-800 border border-obsidian-600 rounded-sm w-full max-w-3xl p-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 mb-3">
          <div className="min-w-0">
            <h3 className="font-heading text-2xl uppercase truncate">{video.title}</h3>
            {video.description && <p className="text-sm text-zinc-400 mt-1">{video.description}</p>}
          </div>
          <button type="button" onClick={onClose} data-testid="video-player-close" className="p-1 text-zinc-500 hover:text-blaze shrink-0" aria-label="Close player">
            <X className="h-5 w-5" />
          </button>
        </div>
        {player}
      </div>
    </div>
  );
};

export default VideoPlayerModal;
